import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './httpService';
import { ConfigService } from './configService';
import { McGriffClaimModel, McGriffLossRatio } from '../components/analytics-page/analytics.model';

@Injectable()
export class AnalyticsService {
    private baseUrl: string;

    constructor(private http: HttpService,
                private config: ConfigService) {
        this.baseUrl = this.config.get('apiUrl') + '/v1';
    }

    public getMcGriffClaims(): Observable<McGriffClaimModel[]> {
        return this.http.get(`${this.baseUrl}/analytics/mcGriffClaims`);
    }

    public getMcGriffLossRatio(): Observable<McGriffLossRatio[]> {
        return this.http.get(`${this.baseUrl}/analytics/mcGriffLossRatio`);
    }
}